import * as yup from "yup";
import { Language } from "../../../language/English";
export const ServiceValidation = () => {
    return yup.object().shape({
        url : yup.string().min(3).max(250).required().label(Language.URL),
        shortDescription : yup.string().max(690).label(Language.SERVICE_DESCRIPTION),
    });
}